import FlexContainerBase from './_flex-container-base.js'
import FlexItemBase from './_flex-item-base.js'
import ConfigurablePane from './_configurable-pane.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'
import ConfigurableSize from './_configurable-size.js'
import ConfigurablePosition from './_configurable-position.js'
import Spinner from './_spinner.js'
import SkeletonPart from './_skeleton-part.js'
import KeyValueMap from './_key-value-map.js'
import Hideable from './_hideable.js'

export default {
  name: 'LoadingView',
  values: {
    mode: 'skeleton',
    style: {
      position: 'static',
      width: '100%',
      alignItems: 'center',
      $mixin: [
        {
          configSet: FlexContainerBase,
        },
        {
          configSet: FlexItemBase,
        },
        {
          configSet: ConfigurablePane,
        },
        {
          configSet: ConfigurableSizeBounds,
        },
        {
          configSet: ConfigurableSize,
        },
        {
          configSet: ConfigurablePosition,
        },
      ],
    },
    spinner: {
      configSet: Spinner,
      configValues: {},
    },
    skeleton: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '100%',
          height: '100%',
        },
      },
    },
    extensionConfigs: {
      configSet: KeyValueMap,
      configValues: {
        UserBalance: {
          mode: 'spinner',
          style: {
            width: '16px',
            height: '16px',
          },
        },
        BreadcrumbsController: {
          style: {
            height: '33px',
          },
        },
        MyAccount: {
          mode: 'spinner',
          style: {
            top: '0px',
            position: 'absolute',
            height: '100%',
          },
        },
        AlertMessageView: {
          mode: 'spinner',
          style: {
            top: '0px',
            position: 'absolute',
            height: '100%',
          },
        },
        DialogMessageView: {
          mode: 'spinner',
          style: {
            top: '0px',
            position: 'absolute',
            height: '100%',
          },
        },
        LoginDialog: {
          mode: 'spinner',
          style: {
            top: '0px',
            position: 'absolute',
            height: '100%',
          },
        },
        ChangePasswordView: {
          mode: 'spinner',
          style: {
            top: '0px',
            position: 'absolute',
            height: '100%',
          },
        },
        BettingCenterController: {
          style: {
            height: '192px',
          },
        },
        BetslipControllerView: {
          style: {
            height: '152px',
          },
        },
        EUBetBuilder: {
          style: {
            height: '229px',
          },
        },
        PlaceBetContent: {
          style: {
            height: '126px',
          },
        },
        QuickBetslipController: {
          style: {
            height: '196px',
          },
        },
        BetReceipt: {
          style: {
            height: '422px',
            _mobile_height: '100%',
          },
        },
        Overask: {
          style: {
            height: '366px',
          },
          spinner: {
            style: {
              container: {
                height: '32px',
              },
            },
            image: {
              style: {
                flexBasis: '32px',
              },
            },
          },
        },
        VirtualEventsCouponController: {
          style: {
            height: '354px',
            _mobile_height: '295px',
          },
        },
        EventMarkets: {
          style: {
            height: '380px',
          },
        },
        VideoStream: {
          style: {
            height: '306px',
            _mobile_height: '215px',
          },
        },
        SingleLeagueCouponController: {
          style: {
            height: '380px',
          },
        },
        SearchControllerView: {
          style: {
            flexGrow: 0,
            height: '32px',
            width: '160px',
            _mobile_height: '40px',
            _mobile_width: '100%',
          },
        },
        InPlaySideMenu: {
          hide: true,
        },
        SelectableButtonGroup: {
          hide: true,
        },
        Timer: {
          hide: true,
        },
        Popup: {
          hide: true,
        },
        Arrowhead: {
          hide: true,
        },
        ChangedValueIndicator: {
          hide: true,
        },
        Checkbox: {
          hide: true,
        },
        DocumentHead: {
          hide: true,
        },
        DownloadBetPdfButton: {
          hide: true,
        },
        CookieConsent: {
          hide: true,
        },
        SlidingBetslipController: {
          hide: true,
        },
        AccaBarController: {
          hide: true,
        },
        AutoCashoutOnboarding: {
          hide: true,
        },
        BetslipButtonController: {
          hide: true,
        },
        AggregatedMarketPane: {
          hide: true,
        },
        ForeignWindow: {
          hide: true,
        },
        SelectionsLimitToast: {
          hide: true,
        },
        MiniScoreboard: {
          hide: true,
        },
        PageContextMenu: {
          style: {
            height: '260px',
          },
        },
        Clock: {
          style: {
            width: '76px',
          },
        },
        SportsMenuView: {
          style: {
            height: '1050px',
          },
        },
        CustomLinks: {
          style: {
            height: '80px',
          },
        },
        EventListHeader: {
          style: {
            _mobile_height: '56px',
            height: '49px',
          },
        },
        SelectionButtonView: {
          style: {
            height: '44px',
          },
        },
        PasswordInput: {
          style: {
            height: '40px',
          },
        },
        LinkMenu: {
          style: {
            height: '200px',
          },
        },
        AZMenu: {
          style: {
            height: '638px',
          },
        },
        Market: {
          style: {
            minHeight: '44px',
          },
          skeleton: {
            style: {
              minHeight: '44px',
            },
          },
        },
      },
    },
    $mixin: [
      {
        configSet: Hideable,
      },
    ],
  },
  meta: {
    extendable: false,
  },
}
